import { axios } from "~/libs/vp-api-axios-ts";
import * as qs from "qs";

// getでネストしたクエリを投げるために必要↓
const paramsSerializer = (params) => qs.stringify(params);

class BaseRepository {
  async _get(url: string, params = {}) { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
    const results = await axios.get(url, { params, paramsSerializer });
    return results;
  }

  async _post(url: string, params = {}, _options = {}) { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
    const results = await axios.post(url, params, _options);
    return results;
  }

  async _put(url: string, params = {}, _options = {}) { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars
    const results = await axios.put(url, params);
    return results;
  }

  async _delete(url: string, params = {}) { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
    const results = await axios.delete(url, { params, paramsSerializer });
    return results;
  }
}
export default BaseRepository;
